export const OUT_OF_STOCK_ERROR = 'out of stock';
